<template>
  <!-- Welcome Drip Dashboard -->
  <div class="content-wrapper">
    <!-- AsideBar -->
    <AsideBar />
    <!-- Content Header -->
    <div class="content-header">
      <div
        style="
          border-bottom: 1px solid #5c4a4a17;
          margin: auto !important;
          height: 75px;
        "
      >
        <div class="row mb-2">
          <div class="col-sm-12 d-flex flex-column align-items-baseline">
            <h1 class="m-0 text-dark">Trigger Editor</h1>
            <ol class="breadcrumb float-sm-left">
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Home' }"
                >Home</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'Dashboard' }"
                >Dashboard</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'MainCont' }"
                >Website Dashboard</router-link
              >
              <router-link
                tag="li"
                class="breadcrumb-item"
                :to="{ name: 'TriggeredNotifications' }"
                >Triggered Notifications</router-link
              >
              <li class="breadcrumb-item active">Trigger Editor</li>
            </ol>
            <div class="button-group">
              <router-link
                tag="button"
                :to="{ name: 'TriggeredNotifications' }"
                class="btn btn-primary ml-3 mt-8 mb-1"
                style="border-radius: unset; background: #007bff"
              >
                <svg
                  width="14"
                  height="17"
                  viewBox="0 0 14 17"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.00016 16.3333C7.91683 16.3333 8.66683 15.5833 8.66683 14.6667H5.3335C5.3335 15.5833 6.07516 16.3333 7.00016 16.3333ZM12.0002 11.3333V7.16667C12.0002 4.60834 10.6335 2.46667 8.25016 1.9V1.33334C8.25016 0.641669 7.69183 0.0833359 7.00016 0.0833359C6.3085 0.0833359 5.75016 0.641669 5.75016 1.33334V1.9C3.3585 2.46667 2.00016 4.6 2.00016 7.16667V11.3333L0.333496 13V13.8333H13.6668V13L12.0002 11.3333Z"
                    fill="white"
                  />
                </svg>
                Triggered Notification
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Main Content -->
    <section class="content mt-3 pb-12" v-if="!processLoading">
      <div class="container d-flex flex-row" style="margin: 0 auto !important">
        <div class="row d-flex justify-content-center">
          <!-- Name -->
          <div class="col-md-12 text-left py-0">
            <label for="name" class="col-sm-2 col-form-label"
              >Name<em class="asterisk">*</em></label
            >
            <v-text-field
              v-if="notifications !== undefined"
              v-model="notifications.event"
              type="text"
              class="pt-0"
              id="name"
              label="Type trigger selector..."
              :rules="[rules.required]"
              counter
              solo
            ></v-text-field>
          </div>
          <!-- Title -->
          <div class="col-md-12 text-left py-0">
            <label for="title" class="col-sm-2 col-form-label"
              >Title<em class="asterisk">*</em></label
            >
            <v-text-field
              v-if="notifications !== undefined"
              v-model="notifications.title"
              type="text"
              class="pt-0"
              id="title"
              label="Title"
              :rules="[rules.required, rules.titleCounter]"
              counter
              solo
            ></v-text-field>
          </div>
          <!-- Message -->
          <div class="col-md-12 text-left py-0">
            <label for="msg" class="col-sm-2 col-form-label">Message</label>
            <v-text-field
              v-if="notifications !== undefined"
              v-model="notifications.message"
              type="text"
              class="pt-0"
              id="message"
              label="Type your message ... "
              :rules="[rules.required, rules.bodyCounter]"
              counter
              solo
            ></v-text-field>
          </div>
          <!-- Url -->
          <div class="col-md-12 text-left py-0">
            <label for="url" class="col-sm-2 col-form-label">Url</label>
            <v-text-field
              v-if="notifications !== undefined"
              v-model="notifications.url"
              type="text"
              class="pt-0"
              id="url"
              label="URL"
              :rules="[rules.required]"
              counter
              solo
            ></v-text-field>
          </div>
          <!-- Custom Icon -->
          <div class="col-md-12 text-left pl-3 py-0 d-flex flex-column">
            <label for="icon" class="mt-5">Custom Icon</label>
            <v-file-input
              :clearable="false"
              counter
              show-size
              truncate-length="15"
              id="icon"
              accept="image/png, image/jpeg"
              @change="iconImgForPush"
            ></v-file-input>
          </div>
          <v-divider></v-divider>
          <div class="form-group">
            <!-- Additional Customization -->
            <h4 class="mt-3">Additional Customization</h4>
            <!-- Add Large Image -->
            <div class="form-group d-flex flex-row w-100">
              <input
                type="checkbox"
                id="lgImageCheckBox"
                :checked="shwLargeImg"
                @click="shwLargeImg = !shwLargeImg"
                style="height: 24px; margin-right: 7px"
              />
              <div class="d-flex flex-column w-100">
                <label for="large-img" class="mt-1">Add Large Image</label>
                <div class="overflow-hidden">
                  <transition
                    class="animate__faster"
                    enter-active-class="animate__animated animate__slideInDown animate__faster"
                    leave-active-class="animate__animated animate__slideOutUp animate__faster"
                  >
                    <div v-if="shwLargeImg">
                      <v-file-input
                        :clearable="false"
                        counter
                        show-size
                        truncate-length="15"
                        id="lgImage"
                        accept="image/png, image/jpeg"
                        @change="lgImgForPush"
                      ></v-file-input>
                    </div>
                  </transition>
                </div>
              </div>
            </div>
            <!-- Action Buttons -->
            <div class="form-group d-flex flex-column overflow-hidden mb-0">
              <div class="d-flex flex-row-reverse justify-content-end">
                <transition
                  class="animate__faster"
                  enter-active-class="animate__animated animate__fadeIn animate__faster"
                  leave-active-class="animate__animated animate__fadeOut animate__faster"
                >
                  <select
                    name="btns"
                    class="ml-2 px-2 blue"
                    style="color: #fff"
                    v-if="shwActionBtns"
                    :value="shwBtn2 ? 2 : 1"
                    v-on:change="shwBtn2 = !shwBtn2"
                  >
                    <option value="1">1 Button</option>
                    <option value="2">2 Buttons</option>
                  </select>
                </transition>
                <label
                  for="actionBtns"
                  class="flex-row-reverse justify-content-end mt-1"
                  >Action Buttons</label
                >
                <input
                  type="checkbox"
                  id="actionBtns"
                  style="height: 24px; margin-right: 7px"
                  :checked="shwActionBtns"
                  @click="
                    shwActionBtns = !shwActionBtns;
                    shwBtn1 = !shwBtn1;
                    shwBtn2 = false;
                  "
                />
              </div>
              <transition-group
                tag="div"
                class="d-flex flex-column mt-3 mb-3"
                enter-active-class="animate__animated animate__slideInLeft animate__faster"
                leave-active-class="animate__animated animate__slideOutLeft animate__faster"
              >
                <div
                  v-if="shwActionBtns"
                  :key="0"
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span class="font-weight-bolder text-decoration-underline">
                    Button 1
                  </span>
                  <div class="d-flex flex-row">
                    <label for="title" class="text-center mr-2 pl-2"
                      >Title:</label
                    >
                    <input
                      v-model="button1.title"
                      type="text"
                      placeholder="Button 1"
                      class="w-100 text-left border"
                    />
                  </div>
                  <!-- <div class="d-flex flex-row">
                    <label
                      for="url"
                      class="text-center pl-2"
                      style="margin-right: 5px"
                      >URL:</label
                    >
                    <input
                      v-model="notifications.customization.button1.url"
                      type="text"
                      placeholder="URL"
                      class="w-100 text-left border"
                    />
                  </div> -->
                </div>
                <div
                  :key="1"
                  v-if="shwBtn2"
                  class="d-flex flex-column justify-content-center align-items-center"
                >
                  <span class="font-weight-bolder text-decoration-underline">
                    Button 2
                  </span>
                  <div class="d-flex flex-row">
                    <label for="title" class="text-center mr-2 pl-2"
                      >Title:</label
                    >
                    <input
                      v-model="button2.title"
                      type="text"
                      placeholder="Button 2"
                      class="w-100 text-left border"
                    />
                  </div>
                  <!-- <div class="d-flex flex-row">
                    <label
                      for="url"
                      class="text-center pl-2"
                      style="margin-right: 5px"
                      >URL:</label
                    >
                    <input
                      v-model="notifications.customization.button2.url"
                      type="text"
                      placeholder="URL"
                      class="w-100 text-left border"
                    />
                  </div> -->
                </div>
              </transition-group>
            </div>
            <!-- Delay -->
            <v-divider></v-divider>
            <div
              class="form-group d-flex flex-row-reverse justify-content-end mb-4 w-100"
              style="height: 35px"
            >
              <div class="col-sm-10 text-left pl-0" style="direction: rtl">
                <h4 class="mb-5">Delay</h4>
                <h6>Fire notification after</h6>
              </div>
            </div>
            <div
              class="d-flex flex-row col-12 text-right overflow-hidden pl-0 mt-10"
            >
              <div class="mr-3 text-left">
                <label for="src" style="font-size: 13px !important"
                  >Milliseconds:</label
                >

                <v-text-field
                  v-if="notifications !== undefined"
                  v-model="notifications.meta.delay"
                  type="text"
                  class="pt-0"
                  id="delay"
                  label="Delay"
                  counter
                  solo
                ></v-text-field>
              </div>
            </div>
          </div>
        </div>
        <!-- Preview -->
        <div class="preview col-md-6 text-left">
          <div
            class="w-100 overflow-hidden position-relative"
            style="
              min-height: 88px;
              border: 4px solid #dfe1e5;
              border-radius: 4px;
              padding: 50px 25px 18px 25px;
            "
          >
            <div
              class="w-100 position-absolute d-flex justify-content-between preview-header align-items-center"
              style="
                top: 0;
                right: 0;
                height: 25px !important;
                background: #dad9d9 !important;
              "
            >
              <div class="d-flex justify-content-start">
                <div class="overflow-hidden" style="margin-bottom: 2px">
                  <svg
                    width="7"
                    height="7"
                    viewBox="0 0 7 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_i_172_618)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.724 6.7945C5.41989 6.7945 6.79468 5.41971 6.79468 3.72382C6.79468 2.02793 5.41989 0.653137 3.724 0.653137C2.02811 0.653137 0.65332 2.02793 0.65332 3.72382C0.65332 5.41971 2.02811 6.7945 3.724 6.7945Z"
                        fill="#ED6A5E"
                      />
                    </g>
                    <path
                      d="M6.66674 3.72382C6.66674 5.34905 5.34923 6.66655 3.724 6.66655C2.09877 6.66655 0.781265 5.34905 0.781265 3.72382C0.781265 2.09859 2.09877 0.781082 3.724 0.781082C5.34923 0.781082 6.66674 2.09859 6.66674 3.72382Z"
                      stroke="#CE5347"
                      stroke-width="0.25589"
                    />
                    <defs>
                      <filter
                        id="filter0_i_172_618"
                        x="0.65332"
                        y="0.653137"
                        width="6.1416"
                        height="6.14136"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          result="shape"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.53534" />
                        <feComposite
                          in2="hardAlpha"
                          operator="arithmetic"
                          k2="-1"
                          k3="1"
                        />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.92549 0 0 0 0 0.427451 0 0 0 0 0.384314 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="shape"
                          result="effect1_innerShadow_172_618"
                        />
                      </filter>
                    </defs>
                  </svg>
                  <svg
                    width="8"
                    height="7"
                    viewBox="0 0 8 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_i_172_619)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.95935 6.7945C5.65524 6.7945 7.03003 5.41971 7.03003 3.72382C7.03003 2.02793 5.65524 0.653137 3.95935 0.653137C2.26346 0.653137 0.888672 2.02793 0.888672 3.72382C0.888672 5.41971 2.26346 6.7945 3.95935 6.7945Z"
                        fill="#F6BE4F"
                      />
                    </g>
                    <path
                      d="M6.90209 3.72382C6.90209 5.34905 5.58458 6.66655 3.95935 6.66655C2.33412 6.66655 1.01662 5.34905 1.01662 3.72382C1.01662 2.09859 2.33412 0.781082 3.95935 0.781082C5.58458 0.781082 6.90209 2.09859 6.90209 3.72382Z"
                      stroke="#D6A243"
                      stroke-width="0.25589"
                    />
                    <defs>
                      <filter
                        id="filter0_i_172_619"
                        x="0.888672"
                        y="0.653137"
                        width="6.1416"
                        height="6.14136"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          result="shape"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.53534" />
                        <feComposite
                          in2="hardAlpha"
                          operator="arithmetic"
                          k2="-1"
                          k3="1"
                        />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.960784 0 0 0 0 0.768627 0 0 0 0 0.317647 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="shape"
                          result="effect1_innerShadow_172_619"
                        />
                      </filter>
                    </defs>
                  </svg>
                  <svg
                    width="7"
                    height="7"
                    viewBox="0 0 7 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g filter="url(#filter0_i_172_620)">
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.19568 6.7945C4.89157 6.7945 6.26636 5.41971 6.26636 3.72382C6.26636 2.02793 4.89157 0.653137 3.19568 0.653137C1.49979 0.653137 0.125 2.02793 0.125 3.72382C0.125 5.41971 1.49979 6.7945 3.19568 6.7945Z"
                        fill="#62C554"
                      />
                    </g>
                    <path
                      d="M6.13842 3.72382C6.13842 5.34905 4.82091 6.66655 3.19568 6.66655C1.57045 6.66655 0.252945 5.34905 0.252945 3.72382C0.252945 2.09859 1.57045 0.781082 3.19568 0.781082C4.82091 0.781082 6.13842 2.09859 6.13842 3.72382Z"
                      stroke="#58A942"
                      stroke-width="0.25589"
                    />
                    <defs>
                      <filter
                        id="filter0_i_172_620"
                        x="0.125"
                        y="0.653137"
                        width="6.1416"
                        height="6.14136"
                        filterUnits="userSpaceOnUse"
                        color-interpolation-filters="sRGB"
                      >
                        <feFlood
                          flood-opacity="0"
                          result="BackgroundImageFix"
                        />
                        <feBlend
                          mode="normal"
                          in="SourceGraphic"
                          in2="BackgroundImageFix"
                          result="shape"
                        />
                        <feColorMatrix
                          in="SourceAlpha"
                          type="matrix"
                          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                          result="hardAlpha"
                        />
                        <feOffset />
                        <feGaussianBlur stdDeviation="1.53534" />
                        <feComposite
                          in2="hardAlpha"
                          operator="arithmetic"
                          k2="-1"
                          k3="1"
                        />
                        <feColorMatrix
                          type="matrix"
                          values="0 0 0 0 0.407843 0 0 0 0 0.8 0 0 0 0 0.345098 0 0 0 1 0"
                        />
                        <feBlend
                          mode="normal"
                          in2="shape"
                          result="effect1_innerShadow_172_620"
                        />
                      </filter>
                    </defs>
                  </svg>
                </div>
                <div>
                  <span style="height: 15px !important">
                    <svg
                      width="4"
                      height="7"
                      viewBox="0 0 4 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.56902 6.36268L1.05448 3.84813C1.03814 3.83181 1.02517 3.81244 1.01633 3.7911C1.00748 3.76977 1.00293 3.7469 1.00293 3.72381C1.00293 3.70072 1.00748 3.67785 1.01633 3.65652C1.02517 3.63519 1.03814 3.61581 1.05448 3.59949L3.56902 1.08495"
                        stroke="#575757"
                        stroke-width="0.76767"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                  <span>
                    <svg
                      width="5"
                      height="7"
                      viewBox="0 0 5 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.30988 6.36268L3.82443 3.84813C3.84077 3.83181 3.85373 3.81244 3.86258 3.7911C3.87142 3.76977 3.87598 3.7469 3.87598 3.72381C3.87598 3.70072 3.87142 3.67785 3.86258 3.65652C3.85373 3.63519 3.84077 3.61581 3.82443 3.59949L1.30988 1.08495"
                        stroke="#ADADAD"
                        stroke-width="0.76767"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </span>
                </div>
                <div>
                  <span>
                    <svg
                      width="9"
                      height="7"
                      viewBox="0 0 9 7"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M7.9325 0.653137C8.21515 0.653137 8.44428 0.882269 8.44428 1.16492V6.28272C8.44428 6.56537 8.21515 6.7945 7.9325 6.7945H1.27936C0.99671 6.7945 0.767578 6.56537 0.767578 6.28272V1.16492C0.767578 0.882269 0.99671 0.653137 1.27936 0.653137H7.9325ZM3.83826 1.16492H7.9325V6.28272H3.83826V1.16492ZM3.32648 6.28272H1.27936L1.27936 1.16492H3.32648V6.28272Z"
                        fill="#585758"
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <div
                class="position-relative"
                style="
                  background: linear-gradient(180deg, #fdfdfd 0%, #f3f3f3 100%);
                  padding: 0 35px;
                  height: 13px;
                  border-radius: 2px;
                "
              >
                <span>
                  <svg
                    width="5"
                    height="6"
                    viewBox="0 0 5 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M1.16412 2.83835H0.652344V5.90903H4.74658V2.83835H4.2348V2.32657C4.2348 1.47862 3.54741 0.791229 2.69946 0.791229C1.85152 0.791229 1.16412 1.47862 1.16412 2.32657V2.83835ZM1.6759 2.83835H3.72302V2.32657C3.72302 1.76127 3.26476 1.30301 2.69946 1.30301C2.13417 1.30301 1.6759 1.76127 1.6759 2.32657V2.83835Z"
                      fill="#A09FA0"
                    />
                  </svg>
                </span>
                <span style="font-size: 5px">{{
                  selectedDomain($route.params.id)
                }}</span>
                <span>
                  <svg
                    width="7"
                    height="8"
                    viewBox="0 0 7 8"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.33722 3.35962L5.64023 1.91917L3.33722 0.478729V1.5468C1.90259 1.67609 0.77832 2.88182 0.77832 4.35013C0.77832 5.90468 2.03853 7.16492 3.59311 7.16492C5.14769 7.16492 6.4079 5.90468 6.4079 4.35013V4.09424H5.89612V4.35013C5.89612 5.62205 4.86506 6.65314 3.59311 6.65314C2.32116 6.65314 1.2901 5.62205 1.2901 4.35013C1.2901 3.1647 2.18572 2.18846 3.33722 2.06117V3.35962Z"
                      fill="#7B7C7C"
                    />
                  </svg>
                </span>
              </div>
              <div class="d-flex">
                <div>
                  <svg
                    width="7"
                    height="9"
                    viewBox="0 0 7 9"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M4.69328 2.58193C4.78225 2.69172 4.94343 2.70859 5.05313 2.61963C5.16296 2.53064 5.17982 2.36952 5.09086 2.25969L3.87176 0.755336C3.85652 0.7365 3.83903 0.718821 3.81928 0.702921C3.80192 0.688958 3.78267 0.67637 3.76181 0.665687C3.73282 0.650819 3.70133 0.640136 3.66835 0.634388C3.65011 0.631233 3.63149 0.629578 3.61262 0.629578C3.5594 0.629578 3.50842 0.642635 3.46344 0.665687C3.41871 0.688521 3.38197 0.720008 3.35336 0.755336L2.13438 2.25969C2.04542 2.36949 2.06229 2.53064 2.17212 2.61963C2.28182 2.70859 2.443 2.69172 2.53196 2.58193L3.35673 1.56414V5.74738H3.86851V1.56414L4.69328 2.58193Z"
                      fill="#575757"
                    />
                    <path
                      d="M3.86853 3.18848H3.35675V3.70026H3.86853V3.18848Z"
                      fill="#575757"
                    />
                    <path
                      d="M4.38031 3.70026H5.91565V7.7945H1.30963V3.70026H2.84497V3.18848H1.30963C1.027 3.18848 0.797852 3.4176 0.797852 3.70026V7.7945C0.797852 8.07716 1.027 8.30628 1.30963 8.30628H5.91565C6.19828 8.30628 6.42743 8.07716 6.42743 7.7945V3.70026C6.42743 3.4176 6.19828 3.18848 5.91565 3.18848H4.38031V3.70026Z"
                      fill="#575757"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width="7"
                    height="7"
                    viewBox="0 0 7 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M6.20282 1.16492H2.62036V1.6767H2.10858V1.16492C2.10858 0.882258 2.33773 0.653137 2.62036 0.653137H6.20282C6.48545 0.653137 6.7146 0.882258 6.7146 1.16492V4.74738C6.7146 5.03004 6.48545 5.25916 6.20282 5.25916H5.69104V4.74738H6.20282V1.16492Z"
                      fill="#575757"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M0.573242 2.70026C0.573242 2.4176 0.802394 2.18848 1.08502 2.18848H4.66748C4.95011 2.18848 5.17926 2.4176 5.17926 2.70026V6.28272C5.17926 6.56538 4.95011 6.7945 4.66748 6.7945H1.08502C0.802394 6.7945 0.573242 6.56538 0.573242 6.28272V2.70026ZM1.08502 2.70026H4.66748V6.28272H1.08502V2.70026Z"
                      fill="#575757"
                    />
                  </svg>
                </div>
                <div>
                  <svg
                    width="7"
                    height="7"
                    viewBox="0 0 7 7"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.85974 0.723816H3.34796V3.28272H0.789062V3.7945H3.34796V6.3534H3.85974V3.7945H6.41864V3.28272H3.85974V0.723816Z"
                      fill="#646565"
                    />
                  </svg>
                </div>
              </div>
            </div>
            <div class="d-flex justify-content-start">
              <em></em>
            </div>
            <div class="border overflow-hidden" style="min-height: 82px">
              <div class="d-flex flex-row">
                <!-- Icon Image -->
                <div class="overflow-hidden">
                  <div
                    v-if="notifications !== undefined"
                    :style="{
                      //display: shwIcons,
                      'background-image': 'url(' + notifications.icon + ')',
                    }"
                    class="prev-icon-img animate__animated"
                    style="height: 80px; width: 80px !important"
                  ></div>
                </div>
                <!-- Title & Message -->
                <div
                  style="
                    width: calc(100% - 80px);
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  "
                  class="pl-2 pt-1 text-left overflow-hidden word-break hide-scrollbar"
                >
                  <div
                    class="prev_title font-weight-bolder"
                    style="color: #4a5156"
                  >
                    {{ notifications.title || "Title" }}
                  </div>
                  <div class="prev_msg pb-1">
                    {{ notifications.body || "Type Your Message ... " }}
                  </div>
                  <small class="domain pb-2">{{
                    selectedDomain($route.params.id)
                  }}</small>
                </div>
              </div>
              <!-- Large Image -->
              <div class="overflow-hidden">
                <transition
                  enter-active-class="animate__animated animate__slideInDown"
                  leave-active-class="animate__animated animate__slideOutUp"
                >
                  <div v-if="shwLargeImg">
                    <div
                      style="
                        background: #fff;
                        height: auto;
                        padding-bottom: 50%;
                      "
                      :style="{
                        'background-image':
                          'url(' + notifications.customization.image ||
                          null + ')',
                      }"
                      class="w-100 prev-lg-img"
                    ></div>
                  </div>
                </transition>
              </div>
              <!-- Buttons Block -->
              <transition-group
                tag="div"
                v-if="shwActionBtns"
                class="btn-group d-flex flex-column"
                enter-active-class="animate__animated animate__backInLeft animate__faster"
                leave-active-class="animate__animated animate__backOutLeft animate__faster"
              >
                <button
                  :key="0"
                  v-if="shwActionBtns || shwBtn1"
                  class="border-bottom border-top color-black m-0 pl-3 py-1 text-center"
                  style="font-weight: 400 !important"
                >
                  {{ button1.title || "Button1" }}
                </button>
                <button
                  :key="1"
                  v-if="shwActionBtns && shwBtn2"
                  class="color-black m-0 pl-3 py-1 text-center"
                  style="font-weight: 400 !important"
                >
                  {{ button2.title || "Button2" }}
                </button>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
      <div class="btn-group d-flex justify-content-center">
        <button type="button" class="btn btn-success mr-2" @click="update">
          Edit
        </button>
        <button type="button" class="btn btn-warning" @click="pushPreview">
          Preview
        </button>
      </div>
    </section>
    <div
      class="spinner-border text-primary position-fixed"
      style="left: 55%; top: 50%"
      v-if="processLoading"
      role="status"
    >
      <span class="sr-only">Loading...</span>
    </div>

    <!-- Success Snackbar -->
    <transition
      class="animate__faster"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <SuccessSnackbar
        v-if="success"
        @update-success="handleUpdateToSuccessSnackbar"
        message="Successfully!"
      />
    </transition>

    <!-- Failure Snackbar -->
    <transition
      class="animate__faster"
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        @update-failure="handleUpdateToFailureSnackbar"
        message="Fill the required fields out!"
      />
    </transition>

    <!-- Error Pop-Up -->
    <Error v-if="error" :error="error" />
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { BSpinner } from "bootstrap-vue";
import AsideBar from "../../websiteDash/AsideBar.vue";
import Customization from "../../../apis/Customization.js";
import SuccessSnackbar from "../../popUps/SuccessSnackbar.vue";
import FailureSnackbar from "../../popUps/FailureSnackbar.vue";
import Error from "../../popUps/Error.vue";
import common from "../../../mixins/common";

export default {
  name: "TriggerEdit",
  components: {
    AsideBar,
    BSpinner,
    SuccessSnackbar,
    FailureSnackbar,
    Error,
  },
  mixins: [common],
  data() {
    return {
      processLoading: true,
      success: false,
      failure: false,
      shwActionBtns: false,
      shwLargeImg: false,
      shwIcons: false,
      shwBtn1: false,
      shwBtn2: false,
      rules: {
        required: (value) => !!value || "Required.",
        titleCounter: (value) =>
          (!!value && value.length <= 30) || "Max 30 characters",
        bodyCounter: (value) =>
          (!!value && value.length <= 50) || "Max 50 characters",
      },
      button1: {
        title: "",
      },
      button2: {
        title: "",
      },
    };
  },
  mounted() {
    this.getTriggers(
      `?where[domain_id]=${this.$route.params.id}&where[id]=${this.$route.params.trigger_id}`
    ).then(() => {
      this.shwLargeImg =
        this.notifications.customization.image !== undefined
          ? !!this.notifications.customization.image
          : null;
      this.shwActionBtns =
        !!this.notifications.customization.button1 ||
        !!this.notifications.customization.button2;
      this.shwBtn1 = this.notifications.customization.button1;
      this.button1.title =
        this.notifications.customization.button1 !== undefined
          ? this.notifications.customization.button1.title
          : "";
      this.shwBtn2 = this.notifications.customization.button2;
      this.button2.title =
        this.notifications.customization.button2 !== undefined
          ? this.notifications.customization.button2.title
          : "";

      setTimeout(() => {
        this.processLoading = false;
      }, 1000);
    });
  },
  computed: {
    ...mapState({
      notifications: (state) => state.triggers.notifications[0],
      error: (state) => state.triggers.errorTrigger,
    }),
    ...mapGetters(["selectedDomain"]),
  },
  methods: {
    ...mapActions(["getTriggers", "updateTrigger"]),
    /**
     * Update trigger notification.
     */
    async update() {
      let formData = new FormData();
      let formData1 = new FormData();
      let icon = document.getElementById("icon");
      let image = document.getElementById("lgImage");

      if (this.notifications.title && this.notifications.event) {
        if (icon && icon.files.length) {
          formData.append("image", icon.files[0]);
          formData.append("type", "image");

          await Customization.uploadImg(formData).then((response) => {
            this.notifications.icon = response.data.data[0].full_url;
          });
        }

        if (this.shwLargeImg && image && image.files.length) {
          formData1.append("image", image.files[0]);
          formData1.append("type", "image");

          await Customization.uploadImg(formData1).then((response) => {
            this.notifications.customization.image =
              response.data.data[0].full_url;
          });
        } else if (
          !this.shwLargeImg &&
          this.notifications.customization.image !== undefined
        ) {
          delete this.notifications.customization.image;
        }

        if (this.button1.title && this.shwActionBtns) {
          this.notifications.customization.button1 = {};
          Object.assign(this.notifications.customization.button1, this.button1);
        } else if (
          this.notifications.customization.button1 !== undefined &&
          (!this.button1.title || !this.shwActionBtns)
        ) {
          delete this.notifications.customization.button1;
        }

        if (this.button2.title && this.shwActionBtns) {
          this.notifications.customization.button2 = {};
          Object.assign(this.notifications.customization.button2, this.button2);
        } else if (
          this.notifications.customization.button2 !== undefined &&
          (!this.button2.title || !this.shwActionBtns)
        ) {
          delete this.notifications.customization.button2;
        }

        this.updateTrigger({
          id: this.$route.params.trigger_id,
          json: this.notifications,
        }).then(() => {
          this.success = true;

          setTimeout(() => {
            this.$router.push({ name: "TriggeredNotifications" });
          }, 1600);
        });
      } else {
        this.failure = true;
      }
    },
    /**
     * Send preview push notification.
     */
    pushPreview() {
      // Check Servive Worker Existence
      if ("serviceWorker" in navigator) {
        // Register SW File
        navigator.serviceWorker.register("/sw.js");
        // Buttons Visiblility
        let shwActionBtns = this.shwActionBtns;
        let shwBtn2 = this.shwBtn2;
        // Title
        let title = this.notifications.title;
        // Message
        let message = this.notifications.body;
        // Buttons Title
        let btn1 = this.button1.title;
        let btn2 = this.button2.title;
        // Buttons Url
        let urlBtn1 = this.notifications.url;
        let urlBtn2 = this.notifications.url;
        // Actions
        let actions = [];
        // Data For Actions
        let data = {};
        // Images
        let icon = "";
        let image = "";

        if (document.querySelectorAll("div.prev-icon-img")[0]) {
          icon =
            document
              .querySelectorAll("div.prev-icon-img")[0]
              .style.backgroundImage.slice(4, -1)
              .replace(/"/g, "") || "";
        }

        if (document.querySelectorAll("div.prev-lg-img")[0]) {
          image =
            document
              .querySelectorAll("div.prev-lg-img")[0]
              .style.backgroundImage.slice(4, -1)
              .replace(/"/g, "") || "";
        }

        // Add Buttons
        if (shwActionBtns) {
          // Add First Button
          data.urlBtn1 = urlBtn1;
          actions.push({
            title: btn1,
            action: "FirstBtnRedirect",
          });
          if (shwBtn2) {
            // Add Second Button
            data.urlBtn2 = urlBtn2;
            actions.push(actions);
            actions[1].title = btn2;
            actions[1].action = "SecondBtnRedirect";
          }
        }
        // Send Push If It Is Granted
        Notification.requestPermission(function (result) {
          if (result === "granted") {
            navigator.serviceWorker.ready.then(function (registration) {
              registration.showNotification(title, {
                icon: icon,
                image: image,
                body: message,
                data: data,
                actions: actions,
              });
            });
          }
        });
      }
    },
    /**
     * Add large image to push notification.
     */
    lgImgForPush() {
      // Large Picture
      var lgImg = document.querySelector(".prev-lg-img");
      var lgImgFile = document.querySelectorAll("#lgImage")[0].files[0];

      // Initialize Reared
      var reader = new FileReader();
      // Set Image Links To Selectors Attribute
      reader.onloadend = function () {
        // Large Image
        //for (let el of lgImg) {
        lgImg.style.backgroundImage = "url(" + reader.result + ")";
        //}
      };
      // Read Content As File (Large Image)
      if (lgImgFile) {
        reader.readAsDataURL(lgImgFile);
      } else {
        lgImg.style.backgroundImage = "";
      }
    },
    /**
     * Add icon image to push notification.
     */
    iconImgForPush() {
      // Icon
      var iconImg = document.querySelectorAll(".prev-icon-img")[0];
      var iconImgFile = document.getElementById("icon").files[0];
      // Initialize Reared
      var reader = new FileReader();

      // Set Image Links To Selectors Attribute
      reader.onloadend = function () {
        // Icon Image
        iconImg.style.backgroundImage = "url(" + reader.result + ")";
      };

      // Read Content As File (Icon)
      if (iconImgFile) {
        reader.readAsDataURL(iconImgFile);
      } else {
        iconImg.src = "";
      }

      //this.shwIcons = "block";
    },
  },
};
</script>

<style>
.height-180 {
  height: 180px !important;
}
.prev-icon-img {
  width: 100% !important;
}
.prev-lg-img,
.prev-icon-img {
  background-size: cover !important;
}
.lgImageAddDrip {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
}
.color-black {
  color: black !important;
}
button.v-icon {
  color: #c6c6c6 !important;
}
.preview-header div div:nth-child(2) span:nth-child(1) {
  margin-right: 1px;
}
.preview-header div div:nth-child(2) span:nth-child(2) {
  padding: 3px 3px 3px 5px;
}
.preview-header div:nth-child(1) div:nth-child(3),
.preview-header div:nth-child(3) div,
.preview-header div:nth-child(3),
.preview-header div:nth-child(2),
.preview-header div:nth-child(2) span:nth-child(1),
.preview-header div:nth-child(2) span:nth-child(3),
.preview-header div:nth-child(1) div:nth-child(3) span {
  display: flex;
  align-items: center;
}
.preview-header div:nth-child(1) div:nth-child(3) {
  margin: 0 !important;
}
.preview-header div:nth-child(1) div:nth-child(3) span,
.preview-header div:nth-child(3) div {
  background: linear-gradient(180deg, #fdfdfd 0%, #f3f3f3 100%);
}
.preview-header div:nth-child(1) div:nth-child(3) span {
  padding: 0 6px;
  border-radius: 2px;
  height: 15px !important;
}
.preview-header div:nth-child(3) div:nth-child(1) {
  padding: 0 6px;
  height: 12px;
  margin: 0 4px;
  border-radius: 2px;
}
.preview-header div:nth-child(3) div:nth-child(2) {
  padding: 0 6px;
  height: 12px;
  margin: 0 4px 0 0;
  border-radius: 2px;
}
.preview-header div:nth-child(3) div:nth-child(3) {
  background: #bdbebe;
  padding: 0 3px;
  height: 14px;
  display: flex;
  align-items: center;
  margin-bottom: -12px;
}
.preview-header div:nth-child(2) span:nth-child(1) {
  height: 8px;
  margin-right: 3px;
}
.preview-header div:nth-child(2) span:nth-child(2) {
  font-size: 5px;
  color: #4c4c4c;
}
.preview-header div:nth-child(2) span:nth-child(3) {
  position: absolute;
  right: 2px;
  height: 10px;
}
</style>
